export function compareByField(a, b, key, dir = "ASC") {
  const aVal = a[key];
  const bVal = b[key];
  if (aVal == null && bVal == null) return 0;
  if (aVal == null) return 1;
  if (bVal == null) return -1;
  if (aVal < bVal) return dir === "ASC" ? -1 : 1;
  if (aVal > bVal) return dir === "ASC" ? 1 : -1;
  return 0;
}

export function sortByField(arr = [], key, dir = "ASC") {
  return [...arr].sort((a, b) => {
    const aEmpty = a[key] === "";
    const bEmpty = b[key] === "";
    if (aEmpty && bEmpty) return 0;
    if (aEmpty) return 1;
    if (bEmpty) return -1;
    return compareByField(a, b, key, dir);
  });
}

export function filterByFieldHas(arr = [], field, vals) {
  const valArr = Array.isArray(vals) ? vals : [vals];
  return arr.filter(material => {
    const fieldVal = material[field];
    return fieldVal != null && valArr.some(v => fieldVal.includes?.(v));
  });
}

export function filterByFieldWithin(arr = [], field, vals) {
  const valSet = new Set(vals);
  return arr.filter(material => valSet.has(material[field]));
}
